import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 24px;
  height: 24px;
  color: #000000;
`

const Minus = ({ title = 'Minus', ...rest }: IconProps) => (
  <StyledIcon viewBox="0 0 64 64" title={title} {...rest}>
    <title>{title}</title>
    <rect data-element="frame" width={24} height={24} rx={3} ry={3} fill="none" />
    <path d="M15.2 30.2h33.6v3.6H15.2z" fill="currentColor" />
  </StyledIcon>
)

Minus.displayName = 'Minus'
Minus.needsWork = true
export default Minus
